import { AuthLayout } from '@/widgets/layouts/auth';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
import { LoginForm } from './components/login-form';
export const LoginPage = () => {
  return <>
      <PageSeo title="Логин" description={`${APP_TITLE} – онлайн-школа делового английского языка. Логин в личный кабинет`} noindex />

      <LoginForm />
    </>;
};
LoginPage.Layout = AuthLayout;